const BANDS = ["bass", "low-mid", "mid", "high-mid", "treble"];
export const Equalizer = ({ playing, bars = 5, className = "" }) => (
  <div className={`flex h-4 items-end gap-[3px] ${playing ? "eq-playing" : ""} ${className}`} aria-hidden="true">
    {BANDS.slice(0, bars).map((band, position) => <span key={band} className="eq-bar w-[3px] rounded-full bg-[#00F0FF]"
      style={{ height: "100%", animationDelay: `${position * 0.13}s`, animationDuration: `${0.7 + (position % 3) * 0.22}s` }} />)}
  </div>
);